<script setup lang="ts">
defineProps({
  color: {
    type: String,
    default: 'primary',
  },
})
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <div class="place-items-center">
      <span :class="'justify-center loading loading-spinner loading-md text-' + color" />
    </div>
  </div>
</template>
